import { moduleData as prologueModule } from './prologueData';
import { moduleData as preprologueModule } from './preprologueData';
import { moduleData as moduleOne } from './moduleOneData';
import { moduleData as moduleTwo } from './moduleTwoData';
import { moduleData as moduleThree } from './moduleThreeData';
import { moduleData as moduleFour } from './moduleFourData';
import { moduleData as moduleFive } from './moduleFiveData';
import { moduleData as moduleSix } from './moduleSixData';
import { moduleData as moduleSeven } from './moduleSevenData';
import { moduleData as moduleEight } from './moduleEightData';
import { moduleData as moduleNine } from './moduleNineData';
import { moduleData as moduleTen } from './moduleTenData';
import { moduleData as moduleEleven } from './moduleElevenData';
import { moduleData as epilogueModule } from './epilogueData';
import { modules as otherModules } from './moduleData';

export const courseModules = [
  preprologueModule,
  prologueModule,
  moduleOne,
  moduleTwo,
  moduleThree,
  moduleFour,
  moduleFive,
  moduleSix,
  moduleSeven,
  moduleEight,
  moduleNine,
  moduleTen,
  moduleEleven,
  epilogueModule,
  ...otherModules,
];